import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function TheOneClubMotivation({ title, imageSource, reasons }) {
    function displayTheOneClubReasons() {
        if (!_.isEmpty(imageSource)) {
            return <div className='image image--titled'>
                <img className='image__img lazyautosizes lazyloaded'
                    data-sizes='auto'
                    alt=''
                    sizes='499px'
                    srcSet={imageSource}>
                </img>
            </div>;
        }

        if (_.isEmpty(reasons)) {
            return null;
        }

        return reasons.map((reason) => {
            return <ul key={_.uniqueId()}>
                <h3>{reason.label}</h3>
                <div dangerouslySetInnerHTML={{ __html: reason.htmlText }}></div>
            </ul>;
        });
    }

    return (
        <div className='why-become-member'>
            <h2>{title}</h2>
            {displayTheOneClubReasons()}
        </div>
    );
}

TheOneClubMotivation.propTypes = {
    title: PropTypes.string.isRequired,
    imageSource: PropTypes.string.isRequired,
    reasons: PropTypes.array.isRequired,
};

export default TheOneClubMotivation;
